import React from "react"
import { View } from "react-native"
import { theme } from "@common/theme/theme"
import TextM from "@common/components/text/TextM"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { IconButton } from "react-native-paper"

/**
 * Inline error banner component with red styling
 * Factorized from ProgressiveAnalysisDisplay for reuse
 *
 * @param {string} message - Error message to display
 * @param {boolean} dismissable - If true, shows a close button
 * @param {function} onDismiss - Callback when close button is pressed
 * @param {object} style - Additional styles
 */
export const ErrorBanner = ({ message, dismissable = false, onDismiss = () => {}, style = {} }) => {
    if (!message) return null

    return (
        <View
            style={{
                backgroundColor: theme.colors.errorLight || "#FFEBEE",
                borderRadius: 8,
                padding: 12,
                marginTop: 10,
                marginBottom: 10,
                flexDirection: "row",
                alignItems: "center",
                borderLeftWidth: 3,
                borderLeftColor: theme.colors.error,
                ...style,
            }}
        >
            <FontAwesome5
                name="exclamation-circle"
                size={16}
                color={theme.colors.error}
                style={{ marginRight: 10 }}
            />
            <TextM
                fontSize={13}
                color={theme.colors.error}
                style={{ flex: 1, marginRight: dismissable ? 0 : 20 }}
                wrap
            >
                {message}
            </TextM>
            {dismissable && (
                <IconButton
                    icon="times"
                    size={18}
                    iconColor={theme.colors.error}
                    onPress={onDismiss}
                    style={{ margin: 0, marginLeft: "auto" }}
                />
            )}
        </View>
    )
}
